import React, { useMemo } from "react";
import { Button } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import ShareModal from "./ShareModal";
import { PermissionCheck } from "components/auth";
import MoveWorkspaceItems from "./MoveWorkspaceItems";
import { EntityType } from "constants/enums";
import {
  deleteContent,
  getWorkspaceDirectories,
  setWorkspaceDirectories,
} from "./actions";
import { ActionsModal } from "components/modals";
import { FileLink } from "components/buttons";
import { Actions, Targets } from "constants/permissions";

const WorkspaceItemPreviewActions = ({
  item,
  directoryId,
  siteRootDirectoryId,
  onDelete,
}) => {
  const dispatch = useDispatch();

  const selection = useMemo(
    () => ({
      selected: [JSON.stringify({ type: EntityType.File, id: item?.id })],
    }),
    [item]
  );

  return item ? (
    <div className="preview-actions">
      <FileLink file={item} As={Button} compact>
        Download
      </FileLink>
      <ShareModal file={item} compact>
        Share
      </ShareModal>
      {item.canEdit && (
        <PermissionCheck target={Targets.File} action={Actions.Edit}>
          <MoveWorkspaceItems
            directoryId={directoryId}
            siteRootDirectoryId={siteRootDirectoryId}
            selection={selection}
            compact
            onClose={() => {
              dispatch(
                getWorkspaceDirectories(siteRootDirectoryId, {
                  pageSize: 15,
                  pageNumber: 1,
                })
              ).then((x) =>
                dispatch(
                  setWorkspaceDirectories(x, siteRootDirectoryId, 1, true)
                )
              );
            }}
          >
            Move
          </MoveWorkspaceItems>
        </PermissionCheck>
      )}

      {item.canEdit && (
        <PermissionCheck target={Targets.File} action={Actions.Delete}>
          <ActionsModal
            submitAction={deleteContent}
            name={item.name}
            actionName="delete"
            onRefresh={onDelete}
            header="Delete File"
            compact
            submitParams={{ ...selection, directoryId }}
          >
            Delete
          </ActionsModal>
        </PermissionCheck>
      )}
    </div>
  ) : null;
};

export default WorkspaceItemPreviewActions;
